import { FC } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContentText from "@mui/material/DialogContentText";
import { IConfirmationProps } from "../../Installment.helper";
import { IOM } from "../../installmentOptionManagement.classes";

export const SCUIConfirmDialog: FC<IConfirmationProps> = ({
  open = false,
  acceptClick,
  rejectClick,
  title,
  content,
  acceptButtonName,
  rejectButtonName,
}) => {
  return (
    <Dialog open={open} onClose={rejectClick} className={IOM.confirmDialog}>
      {title && title != "" ? (
        <DialogTitle className={IOM.confirmDialogTitle}>{title}</DialogTitle>
      ) : (
        <></>
      )}
      <DialogContent className={IOM.confirmDialogContent}>
        <DialogContentText className={IOM.confirmDialogContentText}>
          {content}
        </DialogContentText>
      </DialogContent>
      <DialogActions className={IOM.confirmDialogActions}>
        <Button onClick={rejectClick} className={IOM.btnConfirmReject}>
          {rejectButtonName}
        </Button>
        <Button onClick={acceptClick} autoFocus className={IOM.btnConfirmAccept}>
          {acceptButtonName}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
